// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1-Gvj","choiceBoxes":"toolbarselects_choiceBoxes__1QbjO","simpleField":"toolbarselects_simpleField__1jcI5"};